const OnlineStatusDot = ({ isOnline }) => (
  <span
    style={{
      display: 'inline-block',
      width: 8,
      height: 8,
      backgroundColor: isOnline ? 'limegreen' : 'gray',
      borderRadius: '50%',
      position: "absolute",
      top: 5,
    }}
    title={isOnline ? 'Online' : 'Offline'}
  />
);

export default OnlineStatusDot;